import { Box } from '@mui/material';
import {
  nLoaderSpinner,
  nLoaderOverlay,
  nLoaderBackdrop,
  nLoaderContent,
  spinnerSvg,
  rotating,
  nLoaderSpinnerDisabled
} from './NSpinner.styles';

export const NSpinner = ({
  isDisabled = false,
  overlay = true,
  circleColor,
  progressColor,
  size,
  children
}: {
  isDisabled?: boolean;
  overlay?: boolean;
  circleColor?: string;
  progressColor?: string;
  size?: string;
  children?: React.ReactNode;
}) => {
  const containerStyles = [
    nLoaderSpinner,
    overlay && nLoaderOverlay,
    isDisabled && nLoaderSpinnerDisabled
  ];

  return (
    <Box sx={containerStyles}>
      {overlay && <Box sx={nLoaderBackdrop} />}
      <Box sx={nLoaderContent}>
        <Box
          component='svg'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 48 48'
          fill='none'
          sx={[
            size ? { width: `${size}px`, height: `${size}px` } : spinnerSvg,
            !isDisabled && rotating
          ]}
        >
          <path
            d='M44 24C44 26.6264 43.4827 29.2272 42.4776 31.6537C41.4725 34.0802 39.9993 36.285 38.1421 38.1421C36.285 39.9993 34.0802 41.4725 31.6537 42.4776C29.2272 43.4827 26.6264 44 24 44C21.3736 44 18.7728 43.4827 16.3463 42.4776C13.9198 41.4725 11.715 39.9993 9.85786 38.1421C8.00069 36.285 6.5275 34.0802 5.52241 31.6537C4.51731 29.2272 4 26.6264 4 24C4 21.3736 4.51732 18.7728 5.52241 16.3463C6.5275 13.9198 8.00069 11.715 9.85787 9.85786C11.715 8.00069 13.9198 6.5275 16.3463 5.52241C18.7728 4.51731 21.3736 4 24 4C26.6264 4 29.2272 4.51732 31.6537 5.52241C34.0802 6.5275 36.285 8.00069 38.1421 9.85787C39.9993 11.715 41.4725 13.9198 42.4776 16.3463C43.4827 18.7728 44 21.3736 44 24Z'
            stroke={circleColor || '#eee'}
            strokeWidth='8'
          />
          {!isDisabled && (
            <path
              d='M44 24C44 28.2236 42.6629 32.3388 40.1803 35.7557C37.6978 39.1727 34.1972 41.716 30.1803 43.0211'
              stroke={progressColor || '#a80087'}
              strokeWidth='8'
              strokeLinecap='round'
            />
          )}
        </Box>
        {children}
      </Box>
    </Box>
  );
};
